
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExamFeedbackFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exam"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attemptsAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"durationUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closingAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isProctored"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFeedbackEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"questions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestionFeedbackFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"examConfigurations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExamConfigurationsFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":415}};
    doc.loc.source = {"body":"#import \"fragments/question-feedback.graphql\"\r\n#import \"fragments/exam-configurations.graphql\"\r\n\r\nfragment ExamFeedbackFragment on Exam {\r\n  id\r\n  title\r\n  description\r\n  attemptsAvailable\r\n  durationTime\r\n  durationUnit\r\n  closingAt\r\n  availableAt\r\n  isProctored\r\n  score\r\n  isFeedbackEnabled\r\n  questions {\r\n    ...QuestionFeedbackFragment\r\n  }\r\n  examConfigurations {\r\n    ...ExamConfigurationsFragment\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("fragments/question-feedback.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("fragments/exam-configurations.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ExamFeedbackFragment"] = oneQuery(doc, "ExamFeedbackFragment");
        
